import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  constructor(private restService: RestService) {}

  information(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('company/information', val_params);
  }
  
  updateInformation(data: any) {
    return this.restService.save('company/update/information', data);
  }

  all(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('employee/all', val_params);
  }

  get(val_id: number) {
    return this.restService.get('employee/edit', val_id);
  }

  save(data: any) {
    return this.restService.save('employee/save', data);
  }

  updateSave(data: any) {
    return this.restService.save('employee/update/save', data);
  }

  update(val_id: number, data: any) {
    return this.restService.update('employee/update', val_id, data);
  }

  delete(val_id: number) {
    return this.restService.delete('employee/delete', val_id);
  }
}
